import chroma from "chroma-js";
// to see what text and svg color the squares should have, and also the main input picker
const getLuminance = (hexColor) => {
  try {
    // Use existing chroma instance that's already imported in your code
    const [r, g, b] = chroma(hexColor).rgb().map(val => {
      // Normalize the RGB value
      const sRGB = val / 255;
      // Transform RGB values
      return sRGB <= 0.03928 ? sRGB / 12.92 : Math.pow((sRGB + 0.055) / 1.055, 2.4);
    });

    // Calculate luminance using the coefficients defined by WCAG
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  } catch (e) {
    console.error('Error calculating luminance:', e);
    return 0.5; // Default fallback luminance
  }
};

// Calculate contrast ratio between two colors
const getContrastRatio = (color1, color2) => {
  try {
    const luminance1 = getLuminance(color1);
    const luminance2 = getLuminance(color2);

    const lighter = Math.max(luminance1, luminance2);
    const darker = Math.min(luminance1, luminance2);

    return (lighter + 0.05) / (darker + 0.05);
  } catch (e) {
    console.error('Error calculating contrast ratio:', e);
    return 1; // Default fallback ratio
  }
};

// Choose text color based on contrast
const getTextColor = (backgroundColor, lightColor, darkColor) => {
  const contrastWithLight = getContrastRatio(backgroundColor, lightColor);
  const contrastWithDark = getContrastRatio(backgroundColor, darkColor);

  // Return the color with the better contrast ratio
  return contrastWithLight > contrastWithDark ? lightColor : darkColor;
};

export { getLuminance, getContrastRatio, getTextColor };